export const ACCEPT_TO_DELIVER = "ACCEPT_TO_DELIVER";
export const PICKEDUP_ORDER = "PICKEDUP_ORDER";
export const DELIVER_ORDER = "DELIVER_ORDER";
